export const Url = {
    home: '/',
    portfolio: '/portfolio',
}

export default Url